<template>
  <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">
    <b-row no-gutters>
      <b-col md="3" sm="8">
        {{this.initialValue.descripcio}}
      </b-col>
      <b-col md="2" sm="4">
        <div v-if='this.initialValue.estat=="0"' >Creada</div>
        <div v-if='this.initialValue.estat=="1"' >Assignada</div>
        <div v-if='this.initialValue.estat=="2"' >Activada</div>
        <div v-if='this.initialValue.estat=="3"' >Expirada</div>
      </b-col>
      <b-col md="2" sm="6">
        {{ this.initialValue.dataActivacio!=null?this.initialValue.dataActivacio:'' }}
        <div class="text-start ms-3" v-if="this.showSpinnerActivacio && this.initialValue.estat!='2'"><b-spinner variant="primary" ></b-spinner></div>
      </b-col>
      <b-col md="2" sm="6">
        {{ this.initialValue.dataExpiracio!=null?this.initialValue.dataExpiracio:'' }}   
      </b-col>
      <b-col md="1" sm="6">
      <b-badge variant="light"><b-icon icon="people-fill" class="mr-2"></b-icon>{{ this.initialValue.totalEnquestats }}</b-badge>
      <b-badge class="ml-4" v-if='this.initialValue.estat=="2" || this.initialValue.estat=="3"' pill :variant='this.initialValue.totalRespostes>0?"info":"danger"'>{{this.initialValue.totalRespostes}}</b-badge>
      </b-col>
      <b-col md="2" sm="6" class="btn-group-activacio">
          <b-button-group size="sm" class="mr-2">
          <b-button :disabled='!(this.initialValue.estat=="0" || this.initialValue.estat=="1")' size="sm" variant="outline-primary" @click="onEditarActivacioEnquesta()">
          <b-icon icon="pencil" aria-label="Editar"></b-icon>
          </b-button>
          <!--b-button  :disabled='this.initialValue.estat=="2"' size="sm" variant="outline-primary" @click="onEliminarActivacioEnquesta()">
          <b-icon icon="trash" aria-label="Eliminar"></b-icon>
          </b-button-->                                 
        </b-button-group>
        <b-button-group size="sm">
          <b-button :disabled='!(this.initialValue.estat=="0" || this.initialValue.estat=="1")' size="sm" variant="outline-primary" @click="onAssignarActivacioEnquesta()">
            <b-icon icon="people-fill" aria-label="Assignar"></b-icon>
          </b-button>
          <b-button :disabled='this.initialValue.estat!="1"' size="sm" variant="outline-primary" @click="onActivarActivacioEnquesta()">
            <b-icon icon="play-fill" aria-label="Activar"></b-icon>
          </b-button>
          <b-button :disabled='this.initialValue.estat=="0" || this.initialValue.estat=="1"' size="sm" :variant='this.details?"primary":"outline-primary"' @click="onDetallsActivacioEnquesta()">
                <b-icon :icon='this.details?"dash-square-fill":"plus-square"' aria-label="Detalls"></b-icon>
          </b-button>
          <b-button :disabled='this.initialValue.estat=="0" || this.initialValue.estat=="1"' size="sm" variant="outline-primary" @click="onConsultarResultats({filtres:[{}]})">
                <b-icon icon="graph-up" aria-label="Resultats"></b-icon>
          </b-button>
          <b-button :disabled='this.initialValue.estat=="0" || this.initialValue.estat=="1"' size="sm" variant="outline-primary" @click="onExportarResultats({})">
                <b-icon icon="download" aria-label="Export"></b-icon>
          </b-button>           
        </b-button-group>
      </b-col>
    </b-row>
    <b-collapse class="mt-2" :id="`${'collapse-activacio-quotes-'+this.initialValue.idEnquesta+'-'+this.initialValue.idActivacio}`" >
      <b-list-group flush>
        <template v-if="!showSpinnerQuotes && this.initialValue.quotes==null">
          <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">No hi han quotes definides.</b-list-group-item >
        </template>
        <div class="text-center mt-4" v-if="showSpinnerQuotes"><b-spinner variant="primary" ></b-spinner></div>
        <template v-for="(item,idx) in initialValue.quotes">
           <ItemQuota v-bind:key='idx' v-bind:initialValue="item" mode="consultar"
            v-on:consultar-resultats="onConsultarResultats"
            v-on:exportar-resultats="onExportarResultats"/>                
        </template>
      </b-list-group>
    </b-collapse> 
  </b-list-group-item>
</template>

<script>
import ItemQuota from './ItemQuota.vue';
import quotaService from "@/services/QuotaService";
export default {
  name: "ItemActivacio",
  components: {
    ItemQuota
  },    
  props: {    
     initialValue:{      
     type: Object,
     required: true
    }
  },   
  data() {
    return {activacio: {},details:null, showSpinnerQuotes:true, showSpinnerActivacio:false};
  },
  computed:{

  },   
  methods: {    
    onEditarActivacioEnquesta(){       
      this.$emit('editar-activacio', this.initialValue);
    },  
    onEliminarActivacioEnquesta(){       
      this.$emit('eliminar-activacio', this.initialValue);
    },
    onAssignarActivacioEnquesta(){       
      this.$emit('assignar-activacio', this.initialValue);
    },
    onActivarActivacioEnquesta(){
      this.showSpinnerActivacio = true;

      this.$emit('activar-activacio', this.initialValue);
    },    
    onDetallsActivacioEnquesta(){
      if(!this.details){
        this.initQuotesActivacioEnquesta();
        this.$emit('detalls-activacio', this.initialValue);      
        this.$root.$emit('bv::toggle::collapse', 'collapse-activacio-quotes-'+this.initialValue.idEnquesta+'-'+this.initialValue.idActivacio);
        this.details = true;                                 
      }else{
        this.$root.$emit('bv::toggle::collapse', 'collapse-activacio-quotes-'+this.initialValue.idEnquesta+'-'+this.initialValue.idActivacio);
        this.details = false;                                 
      }            
    },
    onConsultarResultats(data){ 
      var act = {};
      act.idActivacio =  this.initialValue.idActivacio;
      data.filtres[0].activacions = [];
      data.filtres[0].activacions.push(act);      
      this.$emit('consultar-resultats', data);
    },
    onExportarResultats(data){
      data.idActivacio = this.initialValue.idActivacio;        
      this.$emit('exportar-resultats', data);
    },
    async initQuotesActivacioEnquesta(){
      try{
        this.showSpinnerQuotes=true
        this.initialValue.quotes = [];
        console.log("this.initialValue", this.initialValue)
        const response = await quotaService.listQuotaByActivacioEnquesta(this.initialValue);
        console.log(response.data);
        this.initialValue.quotes = response.data;
        this.showSpinnerQuotes = false;
      }catch(e){
        /*console.error(e.response.data);
        console.error(e.response.data.error);
        console.error(e.message);*/
        console.log(e);
      }
    }
  },
  mounted() {
    // console.log("MONTANDO ITEM_ACTIVACIO")
    this.details = false;
    if(this.initialValue!=null){
      this.activacio = this.initialValue;
    }   
  }
};
</script>

<style>
.label-activacio{
  font-weight: 500;
  font-size: 14px;
}
.btn-group-activacio{
  text-align: right;
}
.btn.disabled{
  color: #5f5f69;
}

</style>